@if (model && model.OrganizationResponsible) {
    @if (isLoading) {
        <div class="fancy-loader"></div>
    } @else {
        <control-linkable
            #linkable
            displayValueProp="name"
            [moduleType]="moduleType"
            [linked]="linked"
            [unlinked]="unlinked"
            [hideActions]="true"
            [orderByValueProperty]="true"
            (linkedChange)="linkedChanged($event)"
            [disabled]="!moiPermissions.canLinkControls"
            [showAdvancedFilters]="true"
            [activeFilters]="activeFilters"
        >
        </control-linkable>
    }
} @else {
    <div>{{ 'controls.selectOrgResponsibleFirst' | t }}</div>
}
